import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export interface AppCheckLogFilters {
  reason?: string;
  ip?: string;
  path?: string;
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
}

export const useGetAppCheckLogs = (
  filters: AppCheckLogFilters = {},
  enabled: boolean = true
): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.APP_CHECK_LOGS, filters],
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      staleTime: 30 * 1000,
      cacheTime: 5 * 60 * 1000,
    }
  );
};
